export const LANG: Record<string, string> = {
  en: 'en',
  th: 'th',
  vi: 'vi',
  id: 'id',
  ms: 'ms',
};

export const NOTIFY_LANG: Record<string, string> = {
  en: 'en_US',
  th: 'th_TH',
  vi: 'vi_VN',
  id: 'id_ID',
  ms: 'ms_MY',
};

export const LANG_IDS: Record<string, number> = {
  en: 3,
  th: 4,
  vi: 6,
  id: 7,
  ms: 9,
};

export const DEFAULT_FACE: string = 'https://pic.bstarstatic.com/face/noface_v1.png';

export const DATA_ERROR = Symbol('DATA_ERROR');